import { Route } from './models';
import { Login } from '../../pages/Login/Login';
import { DigitalOrders } from '../../pages/DigitalOrders/DigitalOrders';
import { OrganizationForm } from '../../pages/DigitalOrders/OrganizationForm';
import { Facilities } from '../../pages/DigitalOrders/Facilities';
import { ProductForm } from '../../pages/DigitalOrders/ProductForm';
import { ProductDetailsForm } from '../../pages/DigitalOrders/ProductDetails';
import { OrderSummaryForm } from '../../pages/DigitalOrders/OrderSummary';
import { Redirect } from '../../pages/Redirect/Redirect';
import PublicLayout from '../../components/PublicLayout/PublicLayout';
import PrivateLayout from '../../components/PrivateLayout/PrivateLayout';
import { LogoutRedirect } from '../../pages/LogoutRedirect/LogoutRedirect';
import { ManageOrders } from '../../pages/ManageOrders/ManageOrders';
import { ManageOrderDetails } from '../../pages/ManageOrders/ManageOrderDetails';
import { Unauthorized } from '../../pages/Unauthorized/Unauthorized';
import { Error } from '../../pages/Error/Error';

export const routesSchema: Route[] = [
  {
    name: 'Login',
    path: '/login',
    component: Login,
    exact: true,
    layout: PublicLayout,
  },
  {
    name: 'Redirect',
    path: '/auth/redirect',
    exact: true,
    component: Redirect,
    layout: PublicLayout,
  },
  {
    name: 'LogoutRedirect',
    path: '/logout/redirect',
    exact: true,
    component: LogoutRedirect,
    layout: PublicLayout,
  },
  {
    name: 'DigitalOrders',
    path: '/digital-orders',
    component: DigitalOrders,
    exact: true,
    layout: PrivateLayout,
    private: true,
  },
  {
    name: 'OrganizationForm',
    path: '/digital-orders/:id/organization',
    component: OrganizationForm,
    exact: true,
    layout: PrivateLayout,
    private: true,
  },
  {
    name: 'FacilitiesForm',
    path: '/digital-orders/:id/facilities',
    component: Facilities,
    exact: true,
    layout: PrivateLayout,
    private: true,
  },
  {
    name: 'ProductsForm',
    path: '/digital-orders/:id/products',
    component: ProductForm,
    exact: true,
    layout: PrivateLayout,
    private: true,
  },
  {
    name: 'ProductDetailsForm',
    path: '/digital-orders/:id/product-details',
    component: ProductDetailsForm,
    exact: true,
    layout: PrivateLayout,
    private: true,
  },
  {
    name: 'OrderSummaryForm',
    path: '/digital-orders/:id/summary',
    component: OrderSummaryForm,
    exact: true,
    layout: PrivateLayout,
    private: true,
  },
  {
    name: 'ManageOrders',
    path: '/manage-orders',
    component: ManageOrders,
    exact: true,
    layout: PrivateLayout,
    private: true,
    requiredScopes: ['do:digital-order:read:all'],
  },
  {
    name: 'OrderDetails',
    path: '/manage-orders/:id',
    component: ManageOrderDetails,
    exact: true,
    layout: PrivateLayout,
    private: true,
    requiredScopes: ['do:digital-order:read:all'],
  },
  {
    name: 'Home',
    path: '/',
    exact: true,
    redirectTo: '/digital-orders',
  },
  {
    name: 'Error',
    path: '/error',
    exact: true,
    layout: PublicLayout,
    component: Error,
  },
  {
    name: 'Unauthorized',
    path: '/auth/unauthorized',
    exact: true,
    layout: PrivateLayout,
    component: Unauthorized,
  },
  {
    name: '404',
    redirectTo: '/digital-orders',
  },
];
